module.exports = __webpack_public_path__ + "static/media/Livingitup.09176d1c.svg";